/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupArtistsResponseArtistsInner
 */
export interface LookupArtistsResponseArtistsInner {
    /**
     * 
     * @type {string}
     * @memberof LookupArtistsResponseArtistsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LookupArtistsResponseArtistsInner
     */
    stageName: string;
}

/**
 * Check if a given object implements the LookupArtistsResponseArtistsInner interface.
 */
export function instanceOfLookupArtistsResponseArtistsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function LookupArtistsResponseArtistsInnerFromJSON(json: any): LookupArtistsResponseArtistsInner {
    return LookupArtistsResponseArtistsInnerFromJSONTyped(json, false);
}

export function LookupArtistsResponseArtistsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupArtistsResponseArtistsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
    };
}

export function LookupArtistsResponseArtistsInnerToJSON(value?: LookupArtistsResponseArtistsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
    };
}

